import React, {useState} from 'react';
import {Alert, Tab, Tabs, Typography} from '@mui/material';
import Container from '../../components/Container';
import Main from '../../layouts/Main';
import {useAppDispatch, useAppSelector} from "../../hooks/hooks";
import TourTable from "../../components/agentComponents/TourTable";
import {User} from "../../services/restserver-openapi";
import {setTabNumber} from "../../store/Agent/userOverviewSlice";
import { useNavigate } from "react-router-dom";



const AgentTourOverviewPage = () => {
    const dispatch = useAppDispatch();
    const tabNumber = useAppSelector((state) => state.userOverview.tabNumber);
    const handleChange = (event: any, newValue: React.SetStateAction<number>) => {
        if (typeof newValue === "number") {
            dispatch(setTabNumber(newValue));
        }
    };

    const isVerifiedAgent = useAppSelector((state) => state.user.isVerifiedAgent);

    if (!isVerifiedAgent) {
        return (
            <Main>
                <Container>
                    <Alert severity="error">
                        Sie haben keine Agent-Berechtigung. Womöglich ist Ihr Account noch nicht freigeschaltet.
                    </Alert>
                </Container>
            </Main>
        );
    }

    return (
        <Main>
            <Container>
                <Typography variant="h4" gutterBottom>
                    Tour Management
                </Typography>
                <TourTable />
            </Container>

        </Main>
    );
};

export default AgentTourOverviewPage;